import Vue from 'vue'
import Vuex from 'vuex'

import common from './modules/common'

// Użytkownik (logowanie)
import user from './modules/user'

// Moduł: Co nowego
import releaseNotes from './modules/releaseNotes'

// Dashboard
import dashboard from './modules/dashboard'

// Moduł: Czas pracy
import reports from './modules/reports/reports'
import reporting from './modules/reports/reporting'
import prioritization from './modules/reports/prioritization'

// Moduł: Wysyłki
import manageTracking from './modules/shipments/tracking/manageTracking'
import sendings from './modules/shipments/sendings'
import labels from './modules/shipments/packageLabels/labels'
import addresses from './modules/shipments/packageLabels/addresses'
import shipmentsLabels from './modules/shipments/shipmentsLabels'
import shipmentsOrders from './modules/shipments/shipmentsOrders'
import personalPickups from './modules/shipments/personalPickups'
import labelsGenerator from './modules/shipments/labelsGenerator'

// Moduł: Spedycja
import notification from './modules/shipping/notification'
import configurations from './modules/shipping/configurations'

// Moduł: Zamówienia
import order from './modules/orders/order'
import orderCreate from './modules/orders/orderCreate'
import cooperantsOrder from './modules/orders/cooperantsOrder'
import wmdOrder from './modules/orders/wmdOrder'
import productTemplates from './modules/orders/productTemplates'

// Moduł: Awarie
import accidents from './modules/maintenance/accidents'

// Moduł: dokumenty
import documentsOrders from './modules/documents/documentsOrders'

// Moduł: Notki stanowiskowe
import productionSiteNotes from './modules/notes/productionSiteNotes'

// Moduł: Awizacje
import adviceNotes from './modules/adviceNotes'

// Moduł: Konfiguracje
import papers from './modules/configurations/papers'
import paperGroups from './modules/configurations/paperGroups'
import foldingTypes from './modules/configurations/foldings'
import materials from './modules/configurations/materials'
import productProductionProcesses from './modules/configurations/productProductionProcesses'
import users from './modules/administration/users'
import machines from './modules/configurations/machines'
import products from './modules/configurations/products'
import dieCutters from './modules/configurations/tools/dieCutters'
import nettoMarkUps from './modules/configurations/calculationsCosts/nettoMarkUps'
import tradersMarkUps from './modules/configurations/calculationsCosts/tradersMarkUps'
import productGroupFactors from './modules/configurations/calculationsCosts/productGroupFactors'
import productionSites from './modules/configurations/productionSites'
import rubberRegistry from './modules/configurations/rubberRegistry'

// Moduł: Reklamacje
import complaints from './modules/complaints/complaints'
import qualitativeNotes from './modules/complaints/qualitativeNotes'
import stopCards from './modules/complaints/stopCards'
import internalComplaints from './modules/complaints/internalComplaints'

// Moduł: Kampanie JMD
import campaigns from './modules/campaigns'

// Moduł: Wiki
import wiki from './modules/wiki'

// Moduł: Zlecenia
import jobs from './modules/jobs'

// Moduł: Zlecenia na proof
import jobsForProof from './modules/jobsForProof'

// Moduł: Klienci
import customers from './modules/customers'

// Moduł: Zakupy
import materialReservations from './modules/purchases/materialReservations'
import requests from './modules/purchases/requests'

// Moduł: Rezerwacje
import roomReservations from './modules/administration/roomReservations'
import carReservations from './modules/administration/carReservations'
import costCenterNumbers from './modules/administration/costCenterNumbers'

// Moduł: Zadania
import userTasks from './modules/userTasks'

// Moduł: Kalkulacje
import calculations from './modules/calculations'

// Moduł: Outdoors
import outdoorsLocalizations from './modules/outdoors/outdoorsSettings/outdoorsLocalizations'
import outdoorsLocalizationScreens from './modules/outdoors/outdoorsSettings/outdoorsLocalizationScreens'
import outdoorsLocalizationTeams from './modules/outdoors/outdoorsSettings/outdoorsLocalizationTeams'
import outdoorsLocalizationScreenGroups from './modules/outdoors/outdoorsSettings/outdoorsLocalizationScreenGroups'
import outdoorsLocalizationScreenSizes from './modules/outdoors/outdoorsSettings/outdoorsLocalizationScreenSizes'
import outdoorsLocalizationContractors from './modules/outdoors/outdoorsSettings/outdoorsLocalizationContractors'
import outdoorsCampaigns from './modules/outdoors/outdoorsCampaigns'
import outdoorsMap from './modules/outdoors/outdoorsMap'

// Moduł: Analizy i Raporty
import dailyReportsShiftSummaries from './modules/reportsAndAnalysis/reports/dailyReportsShiftSummaries'
import usersRanking from './modules/reportsAndAnalysis/reports/usersRanking'
import sentOrders from './modules/reportsAndAnalysis/orders/sentOrders'
import placedOrders from './modules/reportsAndAnalysis/orders/placedOrders'
import reportsSummaries from './modules/reportsAndAnalysis/reports/reportsSummaries'
import NCFJobsReports from './modules/reportsAndAnalysis/jobs/NCFJobsReports'
import Prepress from './modules/reportsAndAnalysis/prepress'
import Print from './modules/reportsAndAnalysis/print'
import FVFromXL from './modules/reportsAndAnalysis/fvFromXL'

// Moduł: Dodatkowe płyty
import plateOrders from './modules/prepress/plateOrders'
import prepressJobs from './modules/prepress/jobs'
import cuttingJobs from './modules/cuttingJobs'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        common,
        user,
        releaseNotes,
        dashboard: {
            modules: {
                dashboard
            },
            namespaced: true
        },
        complaints: {
            modules: {
                complaints,
                internalComplaints,
                qualitativeNotes,
                stopCards
            },
            namespaced: true
        },
        reports: {
            modules: {
                reports,
                reporting,
                prioritization
            },
            namespaced: true
        },
        shipments: {
            modules: {
                manageTracking: {
                    modules: {
                        manageTracking
                    },
                    namespaced: true
                },
                sendings: {
                    modules: {
                        sendings
                    },
                    namespaced: true
                },
                packageLabels: {
                    modules: {
                        labels,
                        addresses
                    },
                    namespaced: true
                },
                shipmentsLabels: {
                    modules: {
                        shipmentsLabels
                    },
                    namespaced: true
                },
                shipmentsOrders: {
                    modules: {
                        shipmentsOrders
                    },
                    namespaced: true
                },
                personalPickups: {
                    modules: {
                        personalPickups
                    },
                    namespaced: true
                },
                labelsGenerator: {
                    modules: {
                        labelsGenerator
                    },
                    namespaced: true
                }
            },
            namespaced: true
        },
        shipping: {
            modules: {
                configurations: {
                    modules: {
                        configurations
                    },
                    namespaced: true
                },
                notification: {
                    modules: {
                        notification
                    },
                    namespaced: true
                }
            },
            namespaced: true
        },
        orders: {
            modules: {
                order,
                orderCreate,
                cooperantsOrder,
                wmdOrder,
                productTemplates
            },
            namespaced: true
        },
        maintenance: {
            modules: {
                accidents
            },
            namespaced: true
        },
        documents: {
            modules: {
                documentsOrders
            },
            namespaced: true
        },
        notes: {
            modules: {
                productionSiteNotes
            },
            namespaced: true
        },
        adviceNotes,

        configurations: {
            modules: {
                papers,
                paperGroups,
                materials,
                productProductionProcesses,
                machines,
                products,
                productionSites,
                foldingTypes,
                tools: {
                    modules: {
                        dieCutters
                    },
                    namespaced: true
                },
                calculationsCosts: {
                    modules: {
                        nettoMarkUps,
                        productGroupFactors,
                        tradersMarkUps
                    },
                    namespaced: true
                },
                rubberRegistry,
            },
            namespaced: true
        },
        wiki: {
            modules: {
                wiki
            },
            namespaced: true
        },
        jobs: {
            modules: {
                jobs
            },
            namespaced: true
        },
        jobsForProof: {
            modules: {
                jobsForProof
            },
            namespaced: true
        },
        cuttingJobs: {
            modules: {
                cuttingJobs
            },
            namespaced: true
        },
        customers: {
            modules: {
                customers
            },
            namespaced: true
        },
        purchases: {
            modules: {
                materialReservations,
                requests
            },
            namespaced: true
        },
        administration: {
            modules: {
                roomReservations,
                carReservations,
                users,
                costCenterNumbers
            },
            namespaced: true
        },
        userTasks: {
            modules: {
                userTasks
            },
            namespaced: true
        },
        calculations: {
            modules: {
                calculations
            },
            namespaced: true
        },
        prepress: {
            modules: {
                plateOrders,
                prepressJobs
            },
            namespaced: true
        },
        campaigns: {
            modules: {
                campaigns
            },
            namespaced: true
        },
        outdoors: {
            modules: {
                outdoorsSettings: {
                    modules: {
                        outdoorsLocalizations,
                        outdoorsLocalizationScreens,
                        outdoorsLocalizationTeams,
                        outdoorsLocalizationScreenGroups,
                        outdoorsLocalizationScreenSizes,
                        outdoorsLocalizationContractors
                    },
                    namespaced: true
                },
                outdoorsCampaigns: {
                    modules: {
                        outdoorsCampaigns
                    },
                    namespaced: true
                },
                outdoorsMap: {
                    modules: {
                        outdoorsMap
                    },
                    namespaced: true
                }
            },
            namespaced: true
        },
        reportsAndAnalysis: {
            modules: {
                reports: {
                    modules: {
                        dailyReportsShiftSummaries,
                        usersRanking,
                        reportsSummaries
                    },
                    namespaced: true
                },
                fvFromXL: {
                    modules: {
                        FVFromXL,
                    },
                    namespaced: true
                },
                orders: {
                    modules: {
                        placedOrders,
                        sentOrders
                    },
                    namespaced: true
                },
                prepress: {
                    modules:{
                        Prepress,
                    },
                    namespaced: true,
                },
                jobs: {
                    modules: {
                        NCFJobsReports,
                    },
                    namespaced: true
                },
                print: {
                    modules: {
                        Print,
                    },
                    namespaced: true
                }
            },
            namespaced: true
        }
    }
})
